module.exports = __webpack_public_path__ + "static/media/signup.f7f151df.png";